'use client';

import { ChevronDown } from 'lucide-react';
import React from 'react';

import { clsx } from 'clsx';

import { ICON_SECONDARY } from '@shared/constants/colors';
import { useAccordion } from '@shared/ui/Accordion/Accordion';

import cls from './AccordionHeader.module.scss';

type AccordionHeaderProps = {
  children: React.ReactNode;
  className?: string;
};

export const AccordionHeader: React.FC<AccordionHeaderProps> = ({ children, className }) => {
  const { setIsOpening, isOpening } = useAccordion();
  return (
    <div
      className={clsx(cls.wrap, className, { [cls.open]: isOpening })}
      onClick={setIsOpening}
    >
      {children}

      <div className={cls.trigger}>
        <ChevronDown color={ICON_SECONDARY} />
      </div>
    </div>
  );
};
